<template>
  <div class="flex flex-col gap-2">
    <span>{{ $i18nPresenter.t('Response') }}</span>
    <div class="flex flex-col gap-2">
      <div
        v-for="(item) in submissions"
        :key="item?.optionid"
        class="flex flex-col block-item border border-secondary-20 p-3 rounded gap-2"
      >
        <div>{{ item?.text }}</div>
        <SquareThumbnail
          v-if="item?.image"
          :imageUrl="item?.image"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SquareThumbnail from '@/components-v2/presentation-report/ReportAudienceDetail/SquareThumbnail.vue'

export default {
  components: {
    SquareThumbnail,
  },
  props: {
    answer: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    submissions() {
      return this.answer?.response?.submissions
    },
  },
}
</script>
